import { useTranslations } from 'next-intl'

import { useUpdateReceiptInformation } from '@/features/update-receipt-information'
import { Button } from '@/shared/ui'

type Props = {
  contractId: number
  onSuccess?: () => void
}

export const UpdateReceiptInformationButton = ({
  contractId,
  onSuccess,
}: Props) => {
  const t = useTranslations('receipt_information')

  const { updateReceiptInformation } = useUpdateReceiptInformation({
    contractId,
    onSuccess,
  })

  const handleSaveButtonClick = async () => {
    await updateReceiptInformation()
  }

  return (
    <Button
      type="button"
      variant="solid"
      color="primary"
      size="large"
      fullWidth
      onClick={handleSaveButtonClick}
    >
      {t('button.save')}
    </Button>
  )
}
